import { axiosRequest } from './instance';

export interface UserPreferences {
  id: string;
  userId: string;
  tenantId: string;
  sessionUpdatesNotificationsEnabled: boolean;
  mentionsNotificationsEnabled: boolean;
  schedulingNotificationsEnabled: boolean;
  otherNotificationsEnabled: boolean;
  createdAt: string;
  valid: boolean;
}

const usersAPI = {
  async getPreferences(): Promise<UserPreferences> {
    const res = await axiosRequest.get<UserPreferences>({
      url: '/users/preferences',
      credentials: true,
    });
    return res.data;
  },

  async updatePreferences(
    preferences: UserPreferences,
  ): Promise<UserPreferences> {
    const res = await axiosRequest.put<UserPreferences>({
      url: '/users/preferences',
      data: preferences,
      credentials: true,
    });
    return res.data;
  },
};

export default usersAPI;

